<script>
import { mapActions } from "vuex";

export default {
  props: {
    professional: {
      type: Object,
      required: true
    }
  },

  data() {
    return {
      biography: "",
      valid: true,
      loader: false,
      rules: [
        v =>
          (v && v.length <= this.maxCharacters) ||
          `Máximo ${this.maxCharacters} caracteres`
      ],
      maxCharacters: 1023
    };
  },

  methods: {
    ...mapActions("professionals", ["updateBio"]),
    async save() {
      this.loader = true;

      try {
        let data = {
          profile_id: this.professional.account.profile.id,
          bio: this.biography
        };

        await this.updateBio(data);

        this.professional.account.profile.bio = this.biography;
        this.$toast.success("Biografia atualizada com sucesso!");
      } catch (e) {
        this.$toast.error(e);
      }

      this.loader = false;
    }
  },

  mounted() {
    this.biography = this.professional.account.profile.bio;
  }
};
</script>

<template>
  <v-form v-model="valid">
    <v-textarea
      :rules="rules"
      :counter="maxCharacters"
      :loading="loader"
      v-model="biography"
      label="Biografia"
      placeholder="Insira uma biografia para o profissional..."
      auto-grow
    ></v-textarea>

    <v-layout justify-end>
      <v-btn
        color="primary"
        class="mr-0"
        :disabled="!valid"
        :loading="loader"
        @click="save"
        >salvar</v-btn
      >
    </v-layout>
  </v-form>
</template>

<style scoped></style>



// WEBPACK FOOTER //
// src/components/Professionals/Edit/Tabs/Biography.vue